module.exports = __webpack_public_path__ + "static/img/12.5543841.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/zh/12.png
// module id = ibHV
// module chunks = 0